import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { Select2, Select2WColor } from '../../components/Select2';

import * as XLSX from 'xlsx';
import { del, get, post, put } from '../../controllers/apiController';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import ChatWidget from '../../components/ChatWidget';

import $ from 'jquery';
import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { useSearchParams } from 'react-router-dom';

const Formlar = () => {
    const [searchParams] = useSearchParams();
    const [originalFormlar, setOriginalFormlar] = useState([]);
    const [formlar, setFormlar] = useState([]);
    const [etiketler, setEtiketler] = useState([]);
    const [hizmetEtiketler, setHizmetEtiketler] = useState([]);
    const [temsilciler, setTemsilciler] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [search, setSearch] = useState("");

    const [selectedLabels, setSelectedLabels] = useState([]);
    const [selectedServiceLabels, setSelectedServiceLabels] = useState([]);
    const [selectedSource, setSelectedSource] = useState("");
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [selectedStage, setSelectedStage] = useState('');
    const [selectedSektor, setSelectedSektor] = useState('');
    const [sektorler, setSektorler] = useState([]);
    const [pipelineStages, setPipelineStages] = useState([]);
    const [selectedPipelineStage, setSelectedPipelineStage] = useState('');
    const [showCustomize, setShowCustomize] = useState(false);
    const [colVisibility, setColVisibility] = useState(() => {
        try { return JSON.parse(localStorage.getItem('lup_forms_cols') || '{}'); } catch { return {}; }
    });
    const [filterVisibility, setFilterVisibility] = useState(() => {
        try { return JSON.parse(localStorage.getItem('lup_forms_filters') || '{}'); } catch { return {}; }
    });

    const isColVisible = (key) => colVisibility[key] !== false;
    const isFilterVisible = (key) => filterVisibility[key] !== false;
    const toggleCol = (key) => {
        setColVisibility(prev => { const n = { ...prev, [key]: prev[key] === false ? true : false }; localStorage.setItem('lup_forms_cols', JSON.stringify(n)); return n; });
    };
    const toggleFilter = (key) => {
        setFilterVisibility(prev => { const n = { ...prev, [key]: prev[key] === false ? true : false }; localStorage.setItem('lup_forms_filters', JSON.stringify(n)); return n; });
    };

    const CUSTOMIZABLE_COLS = [
        { key: 'kaynak', label: 'Kaynak' },
        { key: 'tarih', label: 'Tarih' },
        { key: 'kampanya', label: 'Kampanya' },
        { key: 'etiket', label: 'Etiket' },
        { key: 'sektor', label: 'Sektör' },
        { key: 'asama', label: 'Aşama' },
        { key: 'hatirlatma', label: 'Hatırlatma' },
        { key: 'temsilci', label: 'Temsilci' },
    ];

    const CUSTOMIZABLE_FILTERS = [
        { key: 'source', label: 'Kaynak Filtresi' },
        { key: 'stage', label: 'Pipeline Aşama Filtresi' },
        { key: 'sektor', label: 'Sektör Filtresi' },
        { key: 'etiket', label: 'Etiket Filtresi' },
        { key: 'hizmetEtiket', label: 'Hizmet Etiketi Filtresi' },
    ];

    const getLeadStage = (row) => {
        if (row.Kayip)
            return { label: 'Satışa Dönmedi', color: '#dc3545', textColor: '#fff', order: 8 };
        if (row.Satis_Tarihi && !String(row.Satis_Tarihi).startsWith('0000'))
            return { label: 'Satışa Döndü', color: '#28a745', textColor: '#fff', order: 7 };
        if (row.Teklif_Tarihi && !String(row.Teklif_Tarihi).startsWith('0000'))
            return { label: 'Teklif İletildi', color: '#fd7e14', textColor: '#fff', order: 6 };
        if (row.Toplanti_Tarihi)
            return { label: 'Toplantı Yapıldı', color: '#6f42c1', textColor: '#fff', order: 5 };
        if (row.Toplanti_Talep_Tarihi)
            return { label: 'Toplantı Talep', color: '#0dcaf0', textColor: '#000', order: 4 };
        if (row.Arama_Tarihi) {
            if (row.Ulasim_Durumu === 0 || row.Ulasim_Durumu === '0')
                return { label: 'Ulaşılamadı', color: '#ffc107', textColor: '#000', order: 3 };
            return { label: 'Ulaşıldı', color: '#17a2b8', textColor: '#fff', order: 2 };
        }
        return { label: 'Aranmadı', color: '#6c757d', textColor: '#fff', order: 1 };
    };

    const [newLabels, setNewLabels] = useState(null);
    const [newServiceLabels, setNewServiceLabels] = useState(null);
    const [selectedForm, setSelectedForm] = useState(null);

    const [showLabelsModal, setShowLabelsModal] = useState(false);
    const [showServiceLabelsModal, setShowServiceLabelsModal] = useState(false);

    const availableSources = [...new Set(originalFormlar.map(lead => lead.LeadInfo.Kaynak))];

    const availableCampaigns = (() => {
        const seen = new Set();
        const result = [];

        originalFormlar.forEach(lead => {
            const info = lead.LeadInfo || {};
            let campaignName = null;
            let type = null;

            if (info.Kaynak === 'Meta' && info.Kampanya) {
                campaignName = info.Kampanya;
                type = 'meta';
            } else if (['Web Sitesi', 'WordPress', 'Ads'].includes(info.Kaynak) && info.UTM_Campaign) {
                campaignName = info.UTM_Campaign;
                type = 'google';
            }

            if (campaignName && !seen.has(campaignName)) {
                seen.add(campaignName);
                result.push({
                    value: campaignName,
                    label: (
                        <div className="d-flex align-items-center gap-2">
                            <span
                                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                                style={{
                                    width: 22,
                                    height: 22,
                                    backgroundColor: 'rgba(0,0,0,0.03)',
                                    fontSize: 12
                                }}
                            >
                                {type === 'meta' ? (
                                    // Meta (Facebook) ikonu - kendi rengi
                                    <i className='feather-facebook' style={{ color: '#4267B2' }}></i>
                                ) : (
                                    // Google G ikonu - çok renkli
                                    
                                    <svg width="14" height="14" viewBox="-3 0 262 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/><path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/><path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/><path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/></svg>
                                )}
                            </span>
                            <span>{campaignName}</span>
                        </div>
                    )
                });
            }
        });

        if (result.length > 0) {
            result.unshift({
                value: '',
                label: 'Tümü',
            });
        }

        return result;
    })();

    const dateRangeInputRef = useRef(null);
    const [selectedDateRange, setSelectedDateRange] = useState({
        start: null,
        end: null
    });

    const chatRef = useRef();

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const normalizeDate = (date) => {
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    useEffect(() => {
        if (!isLoading) {
            const labelId = searchParams.get('label');
            const serviceLabelId = searchParams.get('service_label');
            const stageParam = searchParams.get('stage');

            if (labelId && !isNaN(parseInt(labelId))) {
                setSelectedLabels([parseInt(labelId)]);
                document.getElementById(`label-${labelId}`).querySelector('input').checked = true;
            }

            if (serviceLabelId && !isNaN(parseInt(serviceLabelId))) {
                setSelectedServiceLabels([parseInt(serviceLabelId)]);
                document.getElementById(`service-label-${serviceLabelId}`).querySelector('input').checked = true;
            }

            if (stageParam) {
                setSelectedStage(stageParam);
            }
        }
    }, [isLoading]);

    useEffect(() => {
        document.title = "Formlar | LEVELUP CRM";

        const fetchData = async () => {
            const res = await get("forms/");

            setOriginalFormlar(res);
            setFormlar(res);
        }

        const fetchEtiketler = async () => {
            const res = await get("labels/");

            const etiketlerMapped = res.map(etiket => {
                return {
                    value: etiket.Etiket_ID,
                    label: etiket.Etiket_Adi,
                    color: "#" + etiket.Etiket_Renk
                }
            });

            setEtiketler(etiketlerMapped);
        }

        const fetchHizmetEtiketler = async () => {
            const res = await get("service-labels/");

            const etiketlerMapped = res.map(etiket => {
                return {
                    value: etiket.Hizmet_Etiket_ID,
                    label: etiket.Etiket_Adi,
                    color: "#" + etiket.Etiket_Renk
                }
            });

            setHizmetEtiketler(etiketlerMapped);
        }

        const fetchTemsilciler = async () => {
            const res = await get("users/company-users");

            const temsilcilerMapped = res.map(temsilci => {
                return {
                    value: temsilci.Kullanici_ID,
                    label: `${temsilci.Kullanici_Adi} ${temsilci.Kullanici_Soyadi}`
                }
            });

            setTemsilciler(temsilcilerMapped);
        }

        const fetchSektorler = async () => {
            try { const r = await get('forms/sektorler'); setSektorler(r?.sektorler || []); } catch { /* ignore */ }
        };

        const fetchPipelineStages = async () => {
            try { const r = await get('settings/pipeline'); setPipelineStages(r?.stages || []); } catch { /* ignore */ }
        };

        const fetchAllData = async () => {
            try {
                await Promise.all([fetchData(), fetchEtiketler(), fetchHizmetEtiketler(), fetchTemsilciler(), fetchSektorler(), fetchPipelineStages()]);

                setIsLoading(false);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
        }

        fetchAllData();

        if (dateRangeInputRef.current) {
            $(dateRangeInputRef.current).daterangepicker(
                {
                    opens: "left",
                    "locale": {
                        "format": "DD.MM.YYYY",
                        "separator": " - ",
                        "applyLabel": "Uygula",
                        "cancelLabel": "İptal",
                        "fromLabel": "Dan",
                        "toLabel": "a",
                        "customRangeLabel": "Seç",
                        "daysOfWeek": [
                            "Pt",
                            "Sl",
                            "Çr",
                            "Pr",
                            "Cm",
                            "Ct",
                            "Pz"
                        ],
                        "monthNames": [
                            "Ocak",
                            "Şubat",
                            "Mart",
                            "Nisan",
                            "Mayıs",
                            "Haziran",
                            "Temmuz",
                            "Ağustos",
                            "Eylül",
                            "Ekim",
                            "Kasım",
                            "Aralık"
                        ],
                        "firstDay": 1
                    }
                },
                async function (start, end, label) {
                    const formattedStart = start.format("YYYY-MM-DD");
                    const formattedEnd = end.format("YYYY-MM-DD");

                    setSelectedDateRange({ start: formattedStart, end: formattedEnd });
                }
            );
        }
    }, []);

    useEffect(() => {
        let filtered = originalFormlar;

        if (selectedLabels.length > 0) {
            filtered = filtered.filter(lead =>
                lead.Etiketler && lead.Etiketler.some(label => selectedLabels.includes(label.Etiket_ID))
            );
        }

        if (selectedServiceLabels.length > 0) {
            filtered = filtered.filter(lead =>
                lead.Hizmet_Etiketleri && lead.Hizmet_Etiketleri.some(label => selectedServiceLabels.includes(label.Hizmet_Etiket_ID))
            );
        }
        
        if (search) {
            const q = search.toLowerCase();
            filtered = filtered.filter(item =>
                item.LeadInfo?.Adi_Soyadi?.toLowerCase().includes(q) ||
                item.LeadInfo?.Telefon?.toLowerCase().includes(q) ||
                item.LeadInfo?.Firma_Adi?.toLowerCase().includes(q)
            );
        }

        if (selectedSource) {
            filtered = filtered.filter(item =>
                item.LeadInfo.Kaynak == selectedSource
            );
        }

        if (selectedCampaign) {
            filtered = filtered.filter(item => {
                const info = item.LeadInfo || {};
                const isMeta = info.Kaynak === 'Meta' && info.Kampanya === selectedCampaign;
                const isGoogle = ['Web Sitesi', 'WordPress', 'Ads'].includes(info.Kaynak) && info.UTM_Campaign === selectedCampaign;
                return isMeta || isGoogle;
            });
        }

        if (selectedDateRange && selectedDateRange.start && selectedDateRange.end) {
            filtered = filtered.filter(lead => {
                const tarih = normalizeDate(lead.LeadInfo.Tarih);
                return tarih >= normalizeDate(selectedDateRange.start) && tarih <= normalizeDate(selectedDateRange.end);
            });
        }

        if (selectedStage) {
            filtered = filtered.filter(item => {
                const stage = getLeadStage(item);
                const stageMap = {
                    not_called: 1,
                    reached: 2,
                    not_reached: 3,
                    meeting_requested: 4,
                    meeting_done: 5,
                    offer_sent: 6,
                    sale: 7,
                    lost: 8
                };
                return stage.order === stageMap[selectedStage];
            });
        }

        if (selectedSektor) {
            filtered = filtered.filter(item => item.LeadInfo?.Sektor === selectedSektor);
        }

        if (selectedPipelineStage) {
            filtered = filtered.filter(item =>
                Number(item.LeadInfo?.Pipeline_Asama_ID) === Number(selectedPipelineStage)
            );
        }

        setFormlar(filtered);
    }, [selectedLabels, selectedServiceLabels, selectedSource, selectedCampaign, search, originalFormlar, selectedDateRange, selectedStage, selectedSektor, selectedPipelineStage]);

    const handleLabelsEditSubmit = async (type) => {
        try {
            const changedLabels = await put(`forms/change-labels/${type}`, {
                formID: selectedForm.Form_ID,
                labelIds: type == "label" ? newLabels.map(label => label.value) : newServiceLabels.map(label => label.value)
            });

            if (type == "label") {
                setFormlar((formlar) => formlar.map(form =>
                    form.Form_ID === selectedForm?.Form_ID
                        ? { ...form, Etiketler: changedLabels }
                        : form
                ));

                setShowLabelsModal(false);
            } else {
                setFormlar((formlar) => formlar.map(form =>
                    form.Form_ID === selectedForm?.Form_ID
                        ? { ...form, Hizmet_Etiketleri: changedLabels }
                        : form
                ));

                setShowServiceLabelsModal(false);
            }

            toast.success("Etiket başarıyla değiştirildi.");
        } catch (error) {
            toast.error(error.response.data.message || "Etiket değiştirilirken bir hata oluştu!");
        }
    }

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const handleDelete = async (formId) => {
        Swal.fire({
            icon: "warning",
            title: "Form Silme",
            html: 'Form\'u silmek istediğinize emin misiniz ? <b class="text-danger">(Bu işlem geri alınamaz)</b>',
            showCancelButton: true,
            confirmButtonText: "Sil",
            cancelButtonText: "İptal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/${formId}`);

                    setOriginalFormlar((prevFormlar) => {
                        return prevFormlar.filter((form) => form.Form_ID !== formId);
                    });

                    toast.success("Form başarıyla silindi.");
                } catch (error) {
                    toast.error(error.response.data.message || "Form silirken bir hata oluştu!");
                }
            }
        });
    }

    const editFormLabels = async (formId, type) => {
        const form = formlar.find(form => form.Form_ID == formId);
        setSelectedForm(form);
        if (type == "label") {
            setNewLabels(etiketler.filter(label =>
                form.Etiketler.some(etiket => etiket.Etiket_ID === label.value)
            ));

            setShowLabelsModal(true);
        } else {
            setNewServiceLabels(hizmetEtiketler.filter(label =>
                form.Hizmet_Etiketleri.some(etiket => etiket.Hizmet_Etiket_ID === label.value)
            ));

            setShowServiceLabelsModal(true);
        }
    }

    const customStyles = {
        noData: {
            style: { padding: '24px', textAlign: 'center' },
        },
        rows: {
            style: { padding: '8px 0', cursor: 'pointer', transition: 'background 0.15s' },
            highlightOnHoverStyle: { backgroundColor: '#f8f9ff', borderBottomColor: '#e9ecef' },
        },
        headCells: {
            style: { fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', paddingTop: '10px', paddingBottom: '10px' },
        },
        cells: {
            style: { paddingTop: '4px', paddingBottom: '4px' },
        },
    };

    const columns = [
        {
            name: 'MÜŞTERİ', // always visible
            cell: row => (
                <a href={`./lead-detail?id=${row.Form_ID}`} className="d-flex flex-column text-decoration-none py-1">
                    <span className="fw-semibold text-dark" style={{ fontSize: '13px' }}>{row.LeadInfo.Adi_Soyadi}</span>
                    {row.LeadInfo.Firma_Adi && (
                        <span className="text-muted" style={{ fontSize: '11px' }}>{row.LeadInfo.Firma_Adi}</span>
                    )}
                    {row.LeadInfo.Telefon && (
                        <span className="text-muted" style={{ fontSize: '11px' }}>
                            <i className="feather-phone me-1" style={{ fontSize: '10px' }}></i>{row.LeadInfo.Telefon}
                        </span>
                    )}
                </a>
            ),
            sortable: true,
            minWidth: '180px'
        },
        {
            _key: 'kaynak',
            name: 'KAYNAK',
            omit: !isColVisible('kaynak'),
            cell: row => (
                <div className="hstack gap-2">
                    <div className="avatar-text avatar-sm">
                        <i className={`feather-${row.LeadInfo.Kaynak?.toLowerCase() === 'meta' ? 'facebook' : row.LeadInfo.Kaynak?.toLowerCase() === 'ads' ? 'trending-up' : 'globe'}`}></i>
                    </div>
                    <span>{row.LeadInfo.Kaynak}</span>
                </div>
            ),
            sortable: false,
            width: '120px'
        },
        {
            _key: 'tarih',
            name: 'TARİH',
            omit: !isColVisible('tarih'),
            selector: row => new Date(row.LeadInfo.Tarih),
            cell: row => {
                const tarih = new Date(row.LeadInfo.Tarih);
                const formatliTarih = `${tarih.getDate().toString().padStart(2, '0')}.${(tarih.getMonth() + 1).toString().padStart(2, '0')}.${tarih.getFullYear()} ${tarih.getHours().toString().padStart(2, '0')}:${tarih.getMinutes().toString().padStart(2, '0')}`;
                return <span className="fw-semibold">{formatliTarih}</span>
            },
            sortable: true
        },
        {
            _key: 'kampanya',
            name: 'KAMPANYA',
            omit: !isColVisible('kampanya'),
            cell: row => {
                const campaign = row.LeadInfo?.UTM_Campaign || row.LeadInfo?.Kampanya || '-';
                return <span className="fw-semibold" title={campaign} style={{ maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{campaign}</span>;
            },
            sortable: false,
            minWidth: '140px'
        },
        {
            _key: 'etiket',
            omit: !isColVisible('etiket'),
            name: 'ETİKET',
            cell: row => {
                const etiketler = row.Etiketler || [];
                return (
                    <div className="d-flex gap-2 align-items-center">
                        {etiketler.length > 0 ? (
                            <>
                                <div className="badge" style={{ backgroundColor: `#${etiketler[0].Etiket_Renk}`, color: `#${etiketler[0].Etiket_Yazi_Renk}` }}>
                                    {etiketler[0].Etiket_Adi}
                                </div>
                                {etiketler.length > 1 && (
                                    <div className="badge" style={{ backgroundColor: "#efefef", color: "#7f7f7f" }}>
                                        +{etiketler.length - 1}
                                    </div>
                                )}
                            </>
                        ) : (
                            <span className="text-muted" style={{ fontSize: '11px' }}>—</span>
                        )}
                        <button className="text-primary p-0 bg-transparent border-0" onClick={() => editFormLabels(row.Form_ID, "label")}>
                            <i className="feather-edit"></i>
                        </button>
                    </div>
                );
            },
            sortable: false
        },
        {
            _key: 'sektor',
            omit: !isColVisible('sektor'),
            name: 'SEKTÖR',
            cell: row => row.LeadInfo?.Sektor ? (
                <span style={{ fontSize: '11px', background: '#f0fdf4', color: '#16a34a', padding: '2px 8px', borderRadius: '6px', fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {row.LeadInfo.Sektor}
                </span>
            ) : <span className="text-muted" style={{ fontSize: '11px' }}>—</span>,
            sortable: false,
            width: '120px'
        },
        {
            _key: 'asama',
            omit: !isColVisible('asama'),
            name: 'AŞAMA',
            cell: row => {
                if (pipelineStages.length > 0) {
                    const ps = pipelineStages.find(s => Number(s.Asama_ID) === Number(row.LeadInfo?.Pipeline_Asama_ID));
                    if (ps) {
                        const bg = ps.Renk + '18';
                        return (
                            <span style={{ fontSize: '11px', background: bg, color: ps.Renk, padding: '2px 9px', borderRadius: '6px', fontWeight: 700, whiteSpace: 'nowrap', border: `1px solid ${ps.Renk}35` }}>
                                {ps.Tur === 'kazanildi' && <i className="feather-award me-1" style={{ fontSize: '9px' }}></i>}
                                {ps.Tur === 'kaybedildi' && <i className="feather-x-circle me-1" style={{ fontSize: '9px' }}></i>}
                                {ps.Ad}
                                {row.LeadInfo?.Pipeline_Alt_Aksiyon && <span style={{ opacity: 0.65, fontSize: '10px' }}> · {row.LeadInfo.Pipeline_Alt_Aksiyon}</span>}
                            </span>
                        );
                    }
                    return <span className="text-muted" style={{ fontSize: '11px' }}>—</span>;
                }
                const stage = getLeadStage(row);
                return (
                    <span className="badge" style={{ backgroundColor: stage.color, color: stage.textColor, fontSize: '11px', whiteSpace: 'nowrap' }}>
                        {stage.label}
                    </span>
                );
            },
            sortable: false,
            width: '150px'
        },
        {
            _key: 'hatirlatma',
            omit: !isColVisible('hatirlatma'),
            name: 'HATIRLATMA',
            cell: row => {
                if (!row.Hatirlatma_Tarihi) return <span className="text-muted" style={{ fontSize: '11px' }}>—</span>;
                const d = new Date(row.Hatirlatma_Tarihi);
                const isOverdue = d < new Date();
                return (
                    <span style={{ fontSize: '11px', color: isOverdue ? '#dc3545' : '#374151', fontWeight: isOverdue ? 700 : 400 }}>
                        {isOverdue && <i className="feather-alert-circle me-1" style={{ fontSize: '10px' }}></i>}
                        {d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: '2-digit' })}
                    </span>
                );
            },
            sortable: false,
            width: '110px'
        },
        {
            _key: 'temsilci',
            omit: !isColVisible('temsilci'),
            name: 'TEMSİLCİ',
            cell: row => row.Temsilci_ID ? (
                <span style={{ fontSize: '11px' }}>{temsilciler.find(t => t.value === row.Temsilci_ID)?.label || '—'}</span>
            ) : <span className="text-muted" style={{ fontSize: '11px' }}>—</span>,
            sortable: false,
            width: '130px'
        },
        {
            name: 'AKSİYON',
            cell: row => (
                <div className="d-flex gap-1">
                    <a href={`./lead-detail?id=${row.Form_ID}`} className="avatar-text avatar-sm" title="Detay">
                        <i className="feather feather-eye"></i>
                    </a>
                    <a href={`tel:${row.LeadInfo.Telefon}`} className="avatar-text avatar-sm text-success" title="Ara">
                        <i className="feather feather-phone"></i>
                    </a>
                    <button onClick={() => handleDelete(row.Form_ID)} className="avatar-text avatar-sm text-danger" title="Sil">
                        <i className="feather feather-trash-2"></i>
                    </button>
                </div>
            ),
            width: '110px'
        }
    ];

    const handleExport = () => {
        const data = formlar;

        const excelData = data.map(row => {
            const stage = pipelineStages.find(s => Number(s.Asama_ID) === Number(row.LeadInfo?.Pipeline_Asama_ID));
            return {
                'ADI SOYADI': row.LeadInfo.Adi_Soyadi,
                'TELEFON': row.LeadInfo.Telefon,
                'KAYNAK': row.LeadInfo.Kaynak,
                'TARIH': row.LeadInfo.Tarih,
                'PİPELİNE AŞAMASI': stage?.Ad || '',
                'SEKTÖR': row.LeadInfo?.Sektor || '',
                'ETİKET': (row.Etiketler || []).map(e => e.Etiket_Adi).join(', '),
                'HATIRLATMA TARIH': row.Hatirlatma_Tarihi || '',
                'TEMSİLCİ': temsilciler.find(t => t.value === row.Temsilci_ID)?.label || ''
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Formlar");

        const wscols = [
            { wch: 30 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 10 },
            { wch: 15 },
            { wch: 20 },
            { wch: 15 }
        ];
        ws['!cols'] = wscols;

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Formlar_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const filterHandler = (e) => {
        const input = e.currentTarget.querySelector('input');
        const value = parseInt(input.value);

        input.checked = !input.checked;

        setSelectedLabels((prevLabels) => {
            if (input.checked) {
                return prevLabels.includes(value) ? prevLabels : [...prevLabels, value];
            } else {
                return prevLabels.filter(label => label !== value);
            }
        });
    };
    
    const serviceFilterHandler = (e) => {
        const input = e.currentTarget.querySelector('input');
        const value = parseInt(input.value);

        input.checked = !input.checked;

        setSelectedServiceLabels((prevLabels) => {
            if (input.checked) {
                return prevLabels.includes(value) ? prevLabels : [...prevLabels, value];
            } else {
                return prevLabels.filter(label => label !== value);
            }
        });
    };

    const analyzeAI = async (message) => {
        try {
            const formsData = formlar.map(form => ({
                ...form.LeadInfo,
                Etiketler: form.Etiketler.map(etiket => etiket.Etiket_Adi).join(', ')
            }));

            const response = await post(`ai/multiple-lead-analysis`, {
                forms: formsData,
                analyzeType: message
            });

            chatRef.current.addAIResponse(response.analysis.replace(/\d+\.\s/g, match => match.trim()));
        } catch (error) {
            chatRef.current.addAIResponse(error?.response?.data?.message || "Yapay zeka analizi sırasında hata oluştu!");
            toast.error(error?.response?.data?.message || "Yapay zeka analizi sırasında hata oluştu!");
        }
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Formlar</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="javascript:void(0);" onClick={handleExport} className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                    <a href="javascript:void(0);" className="btn btn-icon btn-light-brand collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false">
                                        <i className="feather-bar-chart"></i>
                                    </a>
                                    <input className="form-control" type="text" id="dateRangeInput" ref={dateRangeInputRef} style={{ height: '100%' }} />
                                    {/* Kampanya filtre select'i - İLERİDE GEREKİRSE AÇ
                                    <select
                                        className="form-select form-select-sm"
                                        value={selectedCampaign}
                                        onChange={(e) => setSelectedCampaign(e.target.value)}
                                        style={{ width: "220px" }}
                                    >
                                        <option value="">Tüm Kampanyalar (Meta + Google)</option>
                                        {availableCampaigns.map(option => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                    */}
                                    
                                    {/* Normal Etiketler Filtresi */}
                                    {isFilterVisible('etiket') && <div className="dropdown">
                                        <a className="btn btn-icon btn-light-brand" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside">
                                            <i className="feather-filter"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <div className="dropdown-header">
                                                <strong>Etiketler</strong>
                                            </div>
                                            {etiketler.map(etiket => (
                                                <div className="dropdown-item" id={`label-${etiket.value}`} key={etiket.value} onClick={filterHandler}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" id={`etiket-${etiket.value}`} value={etiket.value} hidden />
                                                        <label className="form-check-label w-100" htmlFor={`etiket-${etiket.value}`}>
                                                            <span className="wd-7 ht-7 rounded-circle d-inline-block me-3" style={{ backgroundColor: etiket.color }}></span>
                                                            <span>{etiket.label}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>}

                                    {/* Hizmet Etiketleri Filtresi */}
                                    {isFilterVisible('hizmetEtiket') && <div className="dropdown">
                                        <a className="btn btn-icon btn-light-success" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside">
                                            <i className="feather-tag"></i>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <div className="dropdown-header">
                                                <strong>Hizmet Etiketleri</strong>
                                            </div>
                                            {hizmetEtiketler.map(etiket => (
                                                <div className="dropdown-item" id={`service-label-${etiket.value}`} key={etiket.value} onClick={serviceFilterHandler}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" id={`hizmet-etiket-${etiket.value}`} value={etiket.value} hidden />
                                                        <label className="form-check-label w-100" htmlFor={`hizmet-etiket-${etiket.value}`}>
                                                            <span className="wd-7 ht-7 rounded-circle d-inline-block me-3" style={{ backgroundColor: etiket.color }}></span>
                                                            <span>{etiket.label}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="collapseOne" className="accordion-collapse page-header-collapse collapse">
                        <div className="accordion-body pb-2">
                            <div className="row">
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-users"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Toplam Form</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-facebook"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Facebook'tan Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Meta').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M11.99 13.9v-3.72h9.36c.14.63.25 1.22.25 2.05c0 5.71-3.83 9.77-9.6 9.77c-5.52 0-10-4.48-10-10S6.48 2 12 2c2.7 0 4.96.99 6.69 2.61l-2.84 2.76c-.72-.68-1.98-1.48-3.85-1.48c-3.31 0-6.01 2.75-6.01 6.12s2.7 6.12 6.01 6.12c3.83 0 5.24-2.65 5.5-4.22h-5.51z" /></svg>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Ads'dan Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Ads').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-md-6">
                                    <div className="card stretch stretch-full">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="avatar-text avatar-xl rounded">
                                                        <i className="feather-globe"></i>
                                                    </div>
                                                    <a href="javascript:void(0);" className="fw-bold d-block">
                                                        <span className="d-block">Web Sitesi'nden Gelenler</span>
                                                        <span className="fs-24 fw-bolder d-block">{formlar.filter(form => form.LeadInfo.Kaynak == 'Web Sitesi' || form.LeadInfo.Kaynak == 'Landing Page').length}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header d-flex align-items-center justify-content-between gap-3">
                                        <h5 className="card-title mb-0 flex-shrink-0">
                                            Tüm Formlar
                                            <span className="badge bg-light text-muted ms-2 fw-normal" style={{ fontSize: '12px' }}>{formlar.length}</span>
                                        </h5>
                                        <input
                                            type="text"
                                            placeholder="İsim, firma, telefon ara..."
                                            className="form-control"
                                            style={{ maxWidth: '260px' }}
                                            value={search}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    {/* Filter Bar */}
                                    <div className="px-3 py-2 border-bottom d-flex align-items-center gap-3 flex-wrap" style={{ backgroundColor: '#fafafa', position: 'relative' }}>
                                        {isFilterVisible('source') && (
                                        <div className="d-flex align-items-center gap-1">
                                            <span className="text-muted fw-semibold me-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>KAYNAK</span>
                                            {['', ...availableSources].map(src => (
                                                <button key={src} className="btn btn-sm px-2 py-0"
                                                    style={{ fontSize: '11px', borderRadius: '20px', backgroundColor: selectedSource === src ? '#0d6efd' : '#fff', color: selectedSource === src ? '#fff' : '#6c757d', border: '1px solid ' + (selectedSource === src ? '#0d6efd' : '#dee2e6'), fontWeight: selectedSource === src ? '600' : '400' }}
                                                    onClick={() => setSelectedSource(src)}>
                                                    {src === '' ? 'Tümü' : src}
                                                </button>
                                            ))}
                                        </div>
                                        )}
                                        {isFilterVisible('stage') && pipelineStages.length > 0 && (
                                        <>
                                        <div style={{ width: '1px', height: '20px', backgroundColor: '#dee2e6' }}></div>
                                        <div className="d-flex align-items-center gap-1 flex-wrap">
                                            <span className="text-muted fw-semibold me-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>AŞAMA</span>
                                            <button className="btn btn-sm px-2 py-0"
                                                style={{ fontSize: '11px', borderRadius: '20px', backgroundColor: selectedPipelineStage === '' ? '#6366f1' : '#fff', color: selectedPipelineStage === '' ? '#fff' : '#6366f1', border: '1px solid #6366f1', fontWeight: selectedPipelineStage === '' ? '600' : '400' }}
                                                onClick={() => setSelectedPipelineStage('')}>
                                                Tümü
                                            </button>
                                            {pipelineStages.map(ps => (
                                                <button key={ps.Asama_ID} className="btn btn-sm px-2 py-0"
                                                    style={{ fontSize: '11px', borderRadius: '20px', backgroundColor: selectedPipelineStage === String(ps.Asama_ID) ? ps.Renk : '#fff', color: selectedPipelineStage === String(ps.Asama_ID) ? '#fff' : ps.Renk, border: `1px solid ${selectedPipelineStage === String(ps.Asama_ID) ? ps.Renk : ps.Renk + '60'}`, fontWeight: selectedPipelineStage === String(ps.Asama_ID) ? '600' : '400' }}
                                                    onClick={() => setSelectedPipelineStage(String(ps.Asama_ID))}>
                                                    {ps.Tur === 'kazanildi' && <i className="feather-award me-1" style={{ fontSize: '9px' }}></i>}
                                                    {ps.Tur === 'kaybedildi' && <i className="feather-x-circle me-1" style={{ fontSize: '9px' }}></i>}
                                                    {ps.Ad}
                                                </button>
                                            ))}
                                        </div>
                                        </>
                                        )}
                                        {isFilterVisible('sektor') && sektorler.length > 0 && (
                                        <>
                                        <div style={{ width: '1px', height: '20px', backgroundColor: '#dee2e6' }}></div>
                                        <div className="d-flex align-items-center gap-1 flex-wrap">
                                            <span className="text-muted fw-semibold me-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>SEKTÖR</span>
                                            {['', ...sektorler].map(s => (
                                                <button key={s} className="btn btn-sm px-2 py-0"
                                                    style={{ fontSize: '11px', borderRadius: '20px', backgroundColor: selectedSektor === s ? '#16a34a' : '#fff', color: selectedSektor === s ? '#fff' : '#16a34a', border: '1px solid ' + (selectedSektor === s ? '#16a34a' : '#bbf7d0'), fontWeight: selectedSektor === s ? '600' : '400' }}
                                                    onClick={() => setSelectedSektor(s)}>
                                                    {s === '' ? 'Tümü' : s}
                                                </button>
                                            ))}
                                        </div>
                                        </>
                                        )}
                                        {/* Temizle + Özelleştir */}
                                        <div className="ms-auto d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                                            {(selectedSource || selectedStage || selectedSektor || selectedPipelineStage) && (
                                                <button className="btn btn-sm btn-link text-danger p-0" style={{ fontSize: '11px' }}
                                                    onClick={() => { setSelectedSource(''); setSelectedStage(''); setSelectedSektor(''); setSelectedPipelineStage(''); }}>
                                                    <i className="feather-x me-1"></i>Filtreleri Temizle
                                                </button>
                                            )}
                                            <button className="btn btn-sm btn-light" style={{ fontSize: '11px', borderRadius: '8px' }}
                                                onClick={() => setShowCustomize(s => !s)}>
                                                <i className="feather-sliders me-1"></i>Özelleştir
                                            </button>
                                        </div>

                                        {/* Özelleştir paneli */}
                                        {showCustomize && (
                                            <div style={{ position: 'absolute', right: '12px', top: 'calc(100% + 4px)', zIndex: 200, background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px 20px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', minWidth: '300px' }}>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span style={{ fontWeight: 700, fontSize: '13px', color: '#111' }}>Tablo Özelleştir</span>
                                                    <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: '16px', padding: 0 }} onClick={() => setShowCustomize(false)}>×</button>
                                                </div>
                                                <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', marginBottom: '6px', letterSpacing: '0.5px' }}>SÜTUNLAR</div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '12px' }}>
                                                    {CUSTOMIZABLE_COLS.map(col => (
                                                        <label key={col.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', padding: '4px 0' }}>
                                                            <div onClick={() => toggleCol(col.key)}
                                                                style={{ width: '36px', height: '20px', borderRadius: '10px', background: isColVisible(col.key) ? '#10b981' : '#d1d5db', position: 'relative', transition: 'background 0.15s', cursor: 'pointer', flexShrink: 0 }}>
                                                                <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: isColVisible(col.key) ? '19px' : '3px', transition: 'left 0.15s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                                            </div>
                                                            <span style={{ color: isColVisible(col.key) ? '#111' : '#9ca3af' }}>{col.label}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                                <div style={{ fontSize: '11px', fontWeight: 700, color: '#6b7280', marginBottom: '6px', letterSpacing: '0.5px', borderTop: '1px solid #f0f0f0', paddingTop: '10px' }}>FİLTRELER</div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    {CUSTOMIZABLE_FILTERS.map(fil => (
                                                        <label key={fil.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '13px', padding: '4px 0' }}>
                                                            <div onClick={() => toggleFilter(fil.key)}
                                                                style={{ width: '36px', height: '20px', borderRadius: '10px', background: isFilterVisible(fil.key) ? '#10b981' : '#d1d5db', position: 'relative', transition: 'background 0.15s', cursor: 'pointer', flexShrink: 0 }}>
                                                                <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: isFilterVisible(fil.key) ? '19px' : '3px', transition: 'left 0.15s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                                            </div>
                                                            <span style={{ color: isFilterVisible(fil.key) ? '#111' : '#9ca3af' }}>{fil.label}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={formlar}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                    pointerOnHover
                                                    onRowClicked={row => window.location.href = `./lead-detail?id=${row.Form_ID}`}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showLabelsModal && selectedForm && (
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Etiketleri Düzenle</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowLabelsModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Etiketler</label>
                                        <Select2WColor
                                            key="labelSelect"
                                            onChange={(val) => setNewLabels(val)}
                                            value={newLabels}
                                            isSearchable
                                            isClearable
                                            options={etiketler}
                                            isMulti
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowLabelsModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary" onClick={(e) => handleLabelsEditSubmit("label")}>Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showLabelsModal && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1040 }} onClick={() => setShowLabelsModal(false)} />
                )}

                {showServiceLabelsModal && selectedForm && (
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Hizmet Etiketlerini Düzenle</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowServiceLabelsModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Hizmet Etiketleri</label>
                                        <Select2WColor
                                            key="serviceLabelSelect"
                                            onChange={(val) => setNewServiceLabels(val)}
                                            value={newServiceLabels}
                                            isSearchable
                                            isClearable
                                            options={hizmetEtiketler}
                                            isMulti
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowServiceLabelsModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary" onClick={(e) => handleLabelsEditSubmit("service-label")}>Kaydet</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showServiceLabelsModal && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1040 }} onClick={() => setShowServiceLabelsModal(false)} />
                )}
                
                <ChatWidget
                    ref={chatRef}
                    quickButtons={[
                        {
                            label: "Genel Analiz",
                            value: "Genel Analiz"
                        },
                        {
                            label: "Durum Analizi",
                            value: "Durum Analizi"
                        },
                        {
                            label: "Satışa Dönebilecek Müşteri Analizi",
                            value: "Satışa Dönebilecek Müşteri Analizi"
                        }
                    ]}
                    handleNewUserMessage={analyzeAI}
                />

                <style jsx>{`
                    .dropdown-item, .form-check-label {
                        cursor: pointer;
                    }
                    .dropdown-item:has(> .form-check input:checked) {
                        background-color: #e8f0fe;
                    }
                    .form-check {
                        cursor: pointer;
                        padding-left: 0 !important;
                    }
                `}</style>
            </main>
        </Layout>
    );
};

export default Formlar;